import axios from 'axios';
import { dispensingHistoryService } from '@/app/pharmacy/shared/services/dispensing-history-service';

const state = {

    //****** returned ********
    datasourceGridClinicalServiceReturned:[],
    //------------- CLINICAL SERVICE ADDED GRID DATA-------------------
    datasourceGridClinicalService: {
        schema: {                            
            model: {
                id: "ProductID",
                fields: {
                    ProductID: {
                        editable: false,
                        nullable: true,
                    },

                },
            },                           
        },
        data: [
            {
                "ProductID": 1,
                "Item": "gfghfhgh",
                "Price": "N/A",
                "Quantity": "1",
                "PShare": "yt6y566",
                "PTaxes": 85,
                "IShare": 635353,
                "PkgShare": 58689,
                "Approval": "tyt",
                "Discount": 78,
                "MedQuantity": 150,
                "Date": "11-11-2011",
                "Time": "03:05 pm",
                "MedName": "panadol",
                "MedDose": "700m",
                "Paid": 25,
                "PaidRemain": 30,
                "Total": 0,
                "TotalRemain": 20,
                "DisPercentage": 40
            },
            {
                "ProductID": 2,
                "Item": "Item",
                "Price": "N/A",
                "Quantity": "2",
                "PShare": "Creation Date",
                "PTaxes": 2654,
                "IShare": 468,
                "PkgShare": 458,
                "Approval": "fdffd",
                "Discount": 50,
                "MedQuantity": 180,
                "Date": "10-10-2010",
                "Time": "02:05 pm",
                "MedName": "Octaveos",
                "MedDose": "500m",
                "Paid": 0,
                "PaidRemain": 20,
                "Total": 0,
                "TotalRemain": 20,
                "DisPercentage": 10
            },
        ],
    },
    formDataClinicalService: {
        datasourcePricingFilter: [
            { getPricing: 'gfgfg', Id: '1' },
            { getPricing: 'uyy', Id: '2' },
        ],
        datasourceApprovalFilter: [
            { getApproval: 'gfgfg', Id: '1' },
            { getApproval: 'uyy', Id: '2' },
        ],
        datasourcePaymentFilter: [
            { getPayment: 'gfgfg', Id: '1' },
            { getPayment: 'uyy', Id: '2' },
        ],
        datasourceClassificationFilter: [
            { getClassification: 'gfgfg', Id: '1' },
            { getClassification: 'uyy', Id: '2' },
        ],
        datasourceItemNameFilter: [
            { getItem: 'gfgfg', Id: '1' },
            { getItem: 'uyy', Id: '2' },
        ]
    },
    datasourceGridReturnPopup: {        
        data: [
            { 'Item': 'item1', 'Warehouse': 'warehouse1', 'Batch': 'Batch1', 'SoldUOM': 'uom1', 'SoldQTY': '125', 'ReturnUOM': 'uom11', 'ReturnQty': '123' }
        ],
    },
    datasourceGridDosePopup: {
        data: [
            { 'Medication': 'ay 7aga', 'Dose': 'ay 7aga', 'Notes': 'ay 7aga', 'OrderedBy': 'ay 7aga' }
        ],
    },
};

// Get data
const getters = {
    // -------------------GETTERS FOR CLINICAl SERVICE ADDED GRID 
    datasourceGridClinicalService(state) {
        return state.datasourceGridClinicalService;
    },
    // ------------------GETTERS FOR CLINICAl SERVICE ADDED FORM
    formDataClinicalService(state) {
        return state.formDataClinicalService;
    },
    // -------------------GETTERS FOR CLINICAl SERVICE ADDED RETURN POPUP GRID 
    datasourceGridReturnPopup(state) {
        return state.datasourceGridReturnPopup;
    },
    // -------------------GETTERS FOR CLINICAl SERVICE ADDED DOSE POPUP GRID 
    datasourceGridDosePopup(state) {
        return state.datasourceGridDosePopup;
    },
};


// Update Data "mutations"
const mutations = {

    //************ returened grid **************
    save_datasourceGridClinicalServiceReturned(state, payload) {
        state.datasourceGridClinicalServiceReturned = payload;
    },

    // ------------------MUTATION FOR CLINICAl SERVICE ADDED GRID
    save_datasourceGridClinicalService(state, datasourceGridClinicalService) {
        state.datasourceGridClinicalService = datasourceGridClinicalService;
    },
     // ------------------MUTATION FOR CLINICAl SERVICE ADDED FORM
    save_formDataClinicalService(state, formDataClinicalService) {
        state.formDataClinicalService = formDataClinicalService;
    },
    // ------------------MUTATION FOR CLINICAl SERVICE ADDED RETURN POPUP GRID
    save_datasourceGridReturnPopup(state, datasourceGridReturnPopup) {
        state.datasourceGridReturnPopup = datasourceGridReturnPopup;
    },
    // ------------------MUTATION FOR CLINICAl SERVICE ADDED DOSE POPUP GRID
    save_datasourceGridDosePopup(state, datasourceGridDosePopup) {
        state.datasourceGridDosePopup = datasourceGridDosePopup;
    },
};

const actions = {

    // ********* returened grid *********
    load_datasourceGridClinicalServiceReturned(context, payload) {
        context.commit('save_datasourceGridClinicalServiceReturned', payload);
    },

    //------------- CLINICAL SERVICE ADDED GRID API-------------------
    load_datasourceGridClinicalService(context) {
        //this.visitId = 18716984;
         
        dispensingHistoryService.InitReceptionistVisitViewByCassification(18716984, true, (response) => {
            if (response.data) {
                console.log("clinicaaaaaa", response.data.ClinicalServices)
                //  this.bindAdvancedOutpatientFilterForm(response.data);
                //state.datasourceGridClinicalService = response.data.ClinicalServices;
                context.commit('save_datasourceGridClinicalService', response.data.ClinicalServices);

            }
        })



        //dummy url for load data 
        //https://jsonplaceholder.typicode.com/users
        ////axios.get('')
        ////    .then((result) => {
        ////        context.commit('save_datasourceGridClinicalService', result.data);
        ////    });
    },
    //------------- CLINICAL SERVICE ADDED FORM API-------------------
    load_formDataClinicalService(context) {
        //dummy url for load data 
        //https://jsonplaceholder.typicode.com/users
        axios.get('')
            .then((result) => {
                context.commit('save_formDataClinicalService', result.data);
            });
    },
    //------------- CLINICAl SERVICE ADDED RETURN POPUP GRID API-------------------
    load_datasourceGridReturnPopup(context) {
        //dummy url for load data 
        //https://jsonplaceholder.typicode.com/users
        axios.get('')
            .then((result) => {
                context.commit('save_datasourceGridReturnPopup', result.data);
            });
    },
    //------------- CLINICAl SERVICE ADDED DOSE POPUP GRID API-------------------
    load_datasourceGridDosePopup(context) {
        //dummy url for load data 
        //https://jsonplaceholder.typicode.com/users
        axios.get('')
            .then((result) => {
                context.commit('save_datasourceGridDosePopup', result.data);
            });
    },
};

export default {
    mutations,
    actions,
    state,
    getters
};
